<template>
    <v-sheet tag="section"  :class="$vuetify.breakpoint.smAndDown? 'mb-8' : 'mb-15'">
        <v-row class="form-item-heading" :class="headingBgColor">
            <v-subheader class="text-subtitle-1 align-center" :class="[headingTextColor ? `${headingTextColor}--text` : null, headingPadding, {'font-weight-bold': isHeadingTextBold}]">
              集荷先情報
            </v-subheader>
        </v-row>

        <vb-form-row item-name="法人名/団体名" v-if="isCharibon">
            <template #input>
              {{ formItems.companyName }}
            </template>
        </vb-form-row>

        <vb-form-row item-name="氏名">
            <template #input>
              {{ formItems.lastname }} {{ formItems.firstname }}
            </template>
        </vb-form-row>

        <vb-form-row item-name="カナ">
            <template #input>
              {{ formItems.lastnameKatakana }} {{ formItems.firstnameKatakana }}
            </template>
        </vb-form-row>

        <vb-form-row item-name="生年月日">
            <template #input>
              {{
                new Intl.DateTimeFormat('ja-JP', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                }).format(new Date(formItems.birthdate))
              }}
            </template>
        </vb-form-row>

        <vb-form-row item-name="郵便番号">
            <template #input>
              {{ formItems.postcode }}
            </template>
        </vb-form-row>

        <vb-form-row item-name="集荷先住所">
            <template #input>
              {{ formItems.addressPrefecture }}<br/>
              {{ formItems.addressLocal1 }}<br/>
              {{ formItems.addressLocal2 }}
            </template>
        </vb-form-row>

        <vb-form-row item-name="ご職業" v-if="!isCharibon">
            <template #input>
              {{ formItems.jobLabel }}
            </template>
        </vb-form-row>

        <vb-form-row item-name="電話番号">
            <template #input>
              {{ formItems.telephoneNumber1 }} - {{ formItems.telephoneNumber2 }} - {{ formItems.telephoneNumber3 }}
            </template>
        </vb-form-row>
    </v-sheet>
</template>

<script>
import {mapGetters} from 'vuex';
import VbFormRow from "../../molecules/buy/vb-form-row.vue";

export default {
    name: "pickup-information-confirm",
    components: {VbFormRow},
    props: {
      headingBgColor: {type: String, default: null},
      headingTextColor: {type: String, default: null},
      headingPadding: {type: String, default: null},
      isHeadingTextBold: {type: Boolean, default: false},
    },
    computed: {
      ...mapGetters({
        getBuyFormItems: 'buy/getFormItems',
        getBuyStateFormLabels: 'buyState/getFormLabels',
      }),
      isCharibon() {
        return this.$siteCode === VueConfig.siteCode.charibon;
      },
      formItems() {
          if (this.$route.path === this.routeResolve('AddressReference')){
            // 参照画面用
            return this.getBuyStateFormLabels;
          } else {
            // 入力確認画面用
            return this.getBuyFormItems;
          }
      },
      selectedIdentitySubmissionMethod() {
          const selected = VueConfig.sell.identitySubmissionMethod.find(item => Number(item.id) === this.formItems.identitySubmissionMethodCode);
          return selected.label;
      },
      isDisplayingUpdateScreen() {
        return (this.$route.path === this.routeResolve('AddressReference')) || (this.$route.path === this.routeResolve('AddressConfirm'))
      }
    },
    methods: {
      routeResolve(name) {
        const route = this.$router.resolve({
          name: name,
        }).href
        if(this.$routerBase){
          const reg = new RegExp("^" + this.$routerBase);
          const url = route.replace(reg, "")
          return '/' + url
        } else {
          return route
        }
      },
    }
  }
</script>
